import React, { useEffect } from 'react';
import { rem } from 'design-system';
import useColors from 'hooks/useColors';
import Animated, { cancelAnimation, Easing, useAnimatedStyle, useSharedValue, withDelay, withSequence, withTiming, } from 'react-native-reanimated';
import Svg, { Path } from 'react-native-svg';
// ==================================================
// Shining effect animation
// ==================================================
const ShiningSvg = () => {
    const colors = useColors();
    return (<Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <Path d="M2.5 10.0007C7.1025 10.0007 10 5.43648 10 0.833984C10 5.43648 12.8975 10.0007 17.5 10.0007C12.8975 10.0007 10 14.5648 10 19.1673C10 14.5648 7.1025 10.0007 2.5 10.0007Z" fill={colors.elements.brand}/>
    </Svg>);
};
const AnimatedShining = ({ animate = false, translateDistance = rem(-14), fadeDirection = 'in', duration = 600, delay = 0, style, }) => {
    const translateY = useSharedValue(0);
    const opacity = useSharedValue(0);
    const animatedStyle = useAnimatedStyle(() => ({
        transform: [{ translateY: translateY.value }],
        opacity: opacity.value,
    }));
    useEffect(() => {
        if (animate) {
            cancelAnimation(translateY);
            cancelAnimation(opacity);
            translateY.value = 0;
            opacity.value = 0;
            translateY.value = withDelay(delay, withTiming(translateDistance, {
                duration,
                easing: Easing.bezier(0.19, 1, 0.65, 0.38),
            }));
            opacity.value = withDelay(delay, fadeDirection === 'in'
                ? withSequence(withTiming(1, {
                    duration: duration * 0.5,
                    easing: Easing.inOut(Easing.ease),
                }), withTiming(0, {
                    duration: duration * 0.5,
                    easing: Easing.inOut(Easing.ease),
                }))
                : withSequence(withTiming(1, {
                    duration: duration * 0.1,
                    easing: Easing.inOut(Easing.ease),
                }), withTiming(0, {
                    duration: duration * 0.8,
                    easing: Easing.inOut(Easing.ease),
                })));
        }
        else {
            cancelAnimation(translateY);
            cancelAnimation(opacity);
            translateY.value = 0;
            opacity.value = 0;
        }
    }, [
        animate,
        fadeDirection,
        translateDistance,
        translateY,
        opacity,
        duration,
        delay,
    ]);
    return (<Animated.View style={[animatedStyle, style]}>
      <ShiningSvg />
    </Animated.View>);
};
const AnimatedShiningEffect = ({ animate }) => (<>
    <AnimatedShining animate={animate} fadeDirection="out" style={{
        position: 'absolute',
        right: 38,
        top: -8,
    }}/>
    <AnimatedShining animate={animate} fadeDirection="in" translateDistance={rem(-18)} style={{
        position: 'absolute',
        right: 20,
        top: -20,
    }}/>
    <AnimatedShining animate={animate} fadeDirection="out" style={{
        position: 'absolute',
        right: 0,
        top: -18,
    }}/>
    <AnimatedShining animate={animate} fadeDirection="in" delay={100} style={{
        position: 'absolute',
        right: -20,
        top: -7,
    }}/>
  </>);
export default AnimatedShiningEffect;
